import React, { createContext, useContext, useState, ReactNode } from 'react';
import { OrderDetails, ContainerFillResult } from '../app/services/api/orderManagementClient';

interface ActiveOrderContextType {
  activeOrder: OrderDetails | null;
  containerData: ContainerFillResult | null;
  isActiveOrder: boolean;
  shippingDetails?: {
    deliveryMethod: string;
    deliveryCharge: string;
  };
  setShippingDetails: (details: { deliveryMethod: string; deliveryCharge: string }) => void; 
  setActiveOrder: (orderData: OrderDetails | null) => void;
  setContainerData: (containerInfo: ContainerFillResult | null) => void;
  clearActiveOrder: () => void;
}

const ActiveOrderContext = createContext<ActiveOrderContextType | undefined>(undefined);

interface ActiveOrderProviderProps {
  children: ReactNode;
}

export const ActiveOrderProvider: React.FC<ActiveOrderProviderProps> = ({ children }) => {
  const [activeOrder, setActiveOrder] = useState<OrderDetails | null>(null);
  const [containerData, setContainerData] = useState<ContainerFillResult | null>(null);
  const [shippingDetails, setShippingDetails] = useState({
    deliveryMethod: '-',
    deliveryCharge: '0.00',
  });
  const isActiveOrder = activeOrder !== null;

  const clearActiveOrder = () => {
    setActiveOrder(null);
    setContainerData(null);
    setShippingDetails({
      deliveryMethod: '-',
      deliveryCharge: '0.00',
    });
  };

  const value: ActiveOrderContextType = {
    activeOrder,
    containerData,
    isActiveOrder,
    shippingDetails,
    setActiveOrder,
    setContainerData,
    setShippingDetails,
    clearActiveOrder,
  };

  return (
    <ActiveOrderContext.Provider value={value}>
      {children}
    </ActiveOrderContext.Provider>
  );
};

export const useActiveOrder = (): ActiveOrderContextType => {
  const context = useContext(ActiveOrderContext);
  if (context === undefined) {
    throw new Error('useActiveOrder must be used within an ActiveOrderProvider');
  }
  return context;
};
